import React from 'react';
import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Tooltip, Typography} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {Trans, useTranslation} from "react-i18next";
import {ActionButton, CancelButton} from "../../../../../components/common/ActionButtons";

interface DeactivateLicenseDialogProps {
    open: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

const DeactivateLicenseDialog = ({open, onConfirm, onClose}: DeactivateLicenseDialogProps) => {
    const {t} = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            sx={{ overflow: 'auto', height: '100%'}}
            aria-labelledby="deactivate-license-title"
            aria-modal="true"
            disableEscapeKeyDown
        >
            <DialogTitle
                id="deactivate-license-title"
                sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}
            >
                {t('licenseManager.dialog.title')}

                <Tooltip title={t('common.close')}>
                    <IconButton onClick={onClose} size="small" aria-label={t('common.close') as string}>
                        <CloseIcon />
                    </IconButton>
                </Tooltip>
            </DialogTitle>

            <DialogContent>
                <Stack spacing={2} mt={1}>
                    <Typography variant="body1" color="error">
                        {t('licenseManager.dialog.description')}
                    </Typography>

                    <Typography variant="body1">
                        <Trans
                            i18nKey="licenseManager.dialog.action"
                            components={{ bold: <strong /> }}
                        />
                    </Typography>
                </Stack>
            </DialogContent>

            <DialogActions>
                <CancelButton onClick={onClose}>
                    {t('common.cancel')}
                </CancelButton>

                <ActionButton onClick={onConfirm} color="error">
                    {t('common.confirm')}
                </ActionButton>
            </DialogActions>
        </Dialog>
    );
};

export default DeactivateLicenseDialog;